import { Checkbox, Tooltip } from '@percent/lemonade'

import type { OpportunityFormWaitlistEnabledCheckboxProps } from './waitlist-enabled-checkbox.types'

export function OpportunityFormWaitlistEnabledCheckbox({
  value,
  onChange,
  disabled,
  disabledTooltip,

  label,
  description,
}: Readonly<OpportunityFormWaitlistEnabledCheckboxProps>) {
  const checkbox = (
    <Checkbox
      name="waitlistEnabled"
      value={value ? 'true' : undefined}
      active={value}
      onChange={(e) => onChange(e.currentTarget.checked)}
      label={label}
      helperText={description}
      variant="default"
      disabled={disabled}
    />
  )

  if (disabled && disabledTooltip) {
    return (
      <Tooltip content={disabledTooltip} placement="top-start">
        <div style={{ display: 'inline-block', width: 'fit-content' }}>{checkbox}</div>
      </Tooltip>
    )
  }

  return checkbox
}
